module.exports = __webpack_public_path__ + "img/kyano-logo-dark.fffc126e.svg";